define('adminWebhookHistoryRowToolsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'bootbox',
  'windows',
  'tableFieldView',
  'adminWebhookHistoryEditPopupView',
  'template!adminWebhookHistoryRowToolsView',
  'entities/webhook_history'
], function (
  Module,
  App,
  _,
  $,
  Bootbox,
  Windows,
  FieldView,
  EditPopupView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-webhook-history-row-tools-view table-field-view',

    events: {
      'click .btn-retry': 'onRetry',
      'click .btn-edit': 'onEdit'
    },

    modelEvents: {
      'change:status': 'render'
    },

    serializeData: function () {
      var status = this.model.get('status');
      return {
        canRetry: status !== 'OK' && status !== 'TODO',
        retryLabel: _.i18n('admin.webhookHistory.retry', null, 'Re-execute this webhook'),
        editLabel: _.i18n('admin.webhookHistory.edit', null, 'Edit webhook data')
      };
    },

    onRetry: function (e) {
      e.stopPropagation();
      var self = this;
      Bootbox.confirm(
        _.i18n('admin.webhookHistory.confirmRetry', null,
          'Re-execute this webhook? It will be picked up by the next job run.'),
        function (ok) {
          if (!ok) { return; }
          App.request('webhook-history:retry', self.model.get('id')).done(function () {
            self.refreshTable();
          }).fail(function () {
            Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
          });
        });
    },

    onEdit: function (e) {
      e.stopPropagation();
      var self = this;
      Windows.open({
        view: function () {
          return new EditPopupView({
            model: self.model,
            onConfirm: function () { self.refreshTable(); }
          });
        },
        title: _.i18n('admin.webhookHistory.editTitle', null, 'Webhook data'),
        width: 800,
        height: 700,
        modal: true
      });
    },

    refreshTable: function () {
      var tableView = this.options && this.options.tableView;
      if (tableView && tableView.refresh) { tableView.refresh(); }
    }
  });
});

